import * as React from 'react';
import { FunctionComponent, Fragment, useContext } from 'react';

//MUI
import Button from '@mui/material/Button';

//Custom Components
import UserContext from '@/components/UserContext/UserContext';

//Types
import { IDialogActionButton } from '@/@types/ui/Dialog';
import { UserContextType } from '@/@types/context/UserContext';
import { Tooltip } from '@mui/material';

const DialogActionButton: FunctionComponent<IDialogActionButton> = (props) => {
  const userContext = useContext(UserContext) as UserContextType;

  const { needPermission, startIcon, onClick, variant, disabled, ariaLabel, ariaControls, tooltip } = props;

  return (
    <Fragment>
      {needPermission && !userContext.hasAnyPermission(needPermission) ? null : (
        <Tooltip title={tooltip}>
          <span> {/* wrapped in span so we can have tooltip with disabled button :) */}
            <Button
              color="primary"
              size="medium"
              startIcon={startIcon}
              onClick={onClick}
              variant={variant}
              aria-label={ariaLabel}
              aria-controls={ariaControls}
              disabled={disabled}
            >
              {props.children}
            </Button>
          </span>
        </Tooltip>
      )}
    </Fragment>
  );
};

export default DialogActionButton;
